import React, {Component} from 'react';
import {keyBy} from 'lodash';
import {connect} from 'react-redux';
import {Card, Header, Dropdown, Dimmer, Loader, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import TableListDescription from './table';
import ModalContainer from './Modal';
import './styles.scss';

const initialOption = [{'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'}];

const INITIAL_STATE = {
  'description': '',
  'code': 'AJUSTES1',
  'id': null,
};

class DescriptionMantain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'filterBy': 'TODOS',
      'open': false,
      'action': 'NUEVO',
      ...INITIAL_STATE,
    };
    this.handleAction = this.handleAction.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.DescriptionMantainStockAdjustment,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchSystemParameters({'type': 'text', 'word': 'aj'});
    this.props.fetchDescriptionMantainStockAdjusment();
  }

  handleChangeFilter(e, {value}) {
    this.setState({
      'filterBy': value,
    });
    this.props.fetchDescriptionMantainStockAdjusment(value);
  }

  handleAction(action, item = {...INITIAL_STATE}) {
    this.setState({
      'open': true,
      action,
      'description': item.description,
      'code': item.code,
      'id': item.id,
    });
  }

  handleSubmit() {
    const {optionsObject} = this.props;
    const {action, description, code, id} = this.state;
    const data = {description, code, 'value': optionsObject[code].value};

    if (action === 'ADD') {
      this.props.addDescriptionMantainStockAdjusment(data);
    } else if (action === 'UPDATE') {
      this.props.updateDescriptionMantainStockAdjusment(data, id);
    } else {
      this.props.daleteDescriptionMantainStockAdjusment(id);
    }

    this.setState({
      'open': false,
    });
  }

  handleChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  render() {
    const {filterBy, open, action, code, description} = this.state;
    const {systemParametersLoading, systemParametesOptions, list, loadingList} = this.props;
    if (systemParametersLoading || loadingList) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Cargando...' />
        </Dimmer>
      );
    }

    return (
      <div>
        <Card raised fluid>
          <div className='desc-mant-container'>
            <div className='desc-mant-title'>
              <Header as='h2'>
                Mantenimiento Descripción Ajustes de Stock
              </Header>
            </div>
            <div className='desc-mant-dropdown'>
              <h4> Filtrar por :</h4>
              <Dropdown
                value={filterBy}
                fluid
                selection
                options={[...initialOption, ...systemParametesOptions]}
                onChange={this.handleChangeFilter}
                className="type-selection"
              />
              <Button onClick={() => this.handleAction('ADD')} color='green'>
                NUEVO
              </Button>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <TableListDescription list={list} handleAction={this.handleAction} />
          <ModalContainer
            open={open}
            action={action}
            close={() => {
              this.setState({'open': false});
            }}
            options={systemParametesOptions}
            form={{code, description}}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const options = state.parameters.list.map((item) => ({
    'key': item.code,
    'text': `${item.value}`,
    'value': item.code,
  }));
  const optionsObject = keyBy(state.parameters.list, 'code');

  return {
    'permissions': state.session.permissions,
    'systemParametersLoading': state.parameters.loading,
    'systemParameters': state.parameters.list,
    'systemParametesOptions': options,
    'list': state.stockAdjustmentsListDescription.list,
    'loadingList': state.stockAdjustmentsListDescription.loadingList,
    optionsObject,
  };
};

const {
  navigateTo,
  fetchSystemParameters,
  fetchDescriptionMantainStockAdjusment,
  addDescriptionMantainStockAdjusment,
  updateDescriptionMantainStockAdjusment,
  daleteDescriptionMantainStockAdjusment,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchSystemParameters,
  fetchDescriptionMantainStockAdjusment,
  addDescriptionMantainStockAdjusment,
  updateDescriptionMantainStockAdjusment,
  daleteDescriptionMantainStockAdjusment,
})(DescriptionMantain);
